// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MkqEK{cursor:pointer;flex:1 1 0;min-width:0;align-self:stretch;height:auto;padding:8px}.MkqEK.mSJqt{cursor:not-allowed}.wTzwd{pointer-events:none;flex-shrink:0}._AkX6{flex:1 1 0;min-width:0}._wNBM{overflow-wrap:anywhere}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `MkqEK`,
	"disabled": `mSJqt`,
	"checkbox": `wTzwd`,
	"nameRow": `_AkX6`,
	"name": `_wNBM`
};
export default ___CSS_LOADER_EXPORT___;
